import { render } from "./MustwatchSection.vue?vue&type=template&id=811502ec&scoped=true"
import script from "./MustwatchSection.vue?vue&type=script&lang=js"
export * from "./MustwatchSection.vue?vue&type=script&lang=js"

import "./MustwatchSection.vue?vue&type=style&index=0&id=811502ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-811502ec"]])

export default __exports__